import { PrivateDocumentDto } from '../../models';

export const validatePrivateDocument = (item: PrivateDocumentDto) => {
  const fields: (keyof PrivateDocumentDto)[] = [];

  if (typeof item.country !== 'string') fields.push('country');
  if (typeof item.name !== 'string') fields.push('name');

  return { valid: fields.length === 0, fields };
};
